// Sentry - fully lazy-loaded after page idle to remove from critical path
// Sets up error queue + global handlers, actual SDK loads via requestIdleCallback
// See sentry.ts for implementation details
import './sentry';

// Facebook Pixel - lazy-loaded on user interaction or idle
// Removes ~1s LCP delay and 100-400ms TBT from critical path
// See utils/facebookPixel.ts for implementation details
import { initFacebookPixel } from './utils/facebookPixel';
import { initDeferredAnalytics } from './utils/analyticsLoader';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { ThemeProvider } from './contexts/ThemeContext';
import { App } from './App';
import { initSfamVid } from './utils/attribution';

initFacebookPixel({ strategy: 'interaction-or-idle', idleTimeoutMs: 4000 });
initDeferredAnalytics({ idleTimeoutMs: 4000 });
initSfamVid();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
